import { defer } from 'rxjs';
import { distinctUntilChanged, map, startWith } from 'rxjs/operators';
import { action$, ofType } from '@ardoq/rxbeach';
import { filterInterface } from '@ardoq/filter-interface';
import { ConditionalFormattingAttributes } from '@ardoq/api-types';
import { isEqual } from '@ardoq/common-helpers';
import { notifyFilterColorChanged } from './FilterActions';

const getConditionalFormattingFilters = (): ConditionalFormattingAttributes[] =>
  filterInterface.getConditionalFormattingFilters();

export const conditionalFormattingFilters$ = defer(() =>
  action$.pipe(
    ofType(notifyFilterColorChanged),
    map(getConditionalFormattingFilters),
    startWith(getConditionalFormattingFilters()),
    distinctUntilChanged(isEqual)
  )
);
